import { EyeIcon, Undo2Icon } from "lucide-react";
import type { Me } from "@/api/me";
import { stopViewAs } from "@/auth/view-as";
import { Button } from "@/components/ui/button";

/** Shown on every page while an administrator is testing Pulse as another user or role. */
export function ViewAsBanner({ me }: { me: Me }) {
  const viewAs = me.view_as;
  if (!viewAs) return null;
  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-x-3 gap-y-1 border-b border-warning/40 bg-warning px-4 py-1.5 text-sm text-warning-foreground md:px-6"
    >
      <EyeIcon className="size-4 shrink-0" aria-hidden="true" />
      <p className="min-w-0 flex-1">
        Viewing as <strong className="font-semibold">{viewAs.label}</strong>
        <span className="opacity-80">
          {" "}
          — you see and can do only what {viewAs.kind === "user" ? "they" : "this role"} can. Changes you make are
          logged against {viewAs.real_display_name}.
        </span>
      </p>
      <Button
        size="sm"
        variant="outline"
        className="h-7 border-warning-foreground/30 bg-transparent text-warning-foreground hover:bg-warning-foreground/10"
        onClick={stopViewAs}
      >
        <Undo2Icon /> Back to my access
      </Button>
    </div>
  );
}
